import { render, staticRenderFns } from "./login.vue?vue&type=template&id=2acafafa&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=2acafafa&prod&lang=css"
import style1 from "./login.vue?vue&type=style&index=1&id=2acafafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acafafa",
  null
  
)

export default component.exports